import api from './api';

export const getProfile = () => api.get('/auth/me');
export const updateProfile = (data) => api.put('/auth/update-profile', data);
export const changePassword = (data) => api.put('/auth/change-password', data);
export const getUserActivities = (userId) => api.get('/activities', { params: { userId } });
export const getMyActivities = (limit = 20) => api.get('/activities/my-activities', { params: { limit } });